/**
 * Compresses an image File to be under maxSizeBytes.
 * Returns a base64 string (without the data URI prefix).
 */
const compressImage = (file, maxSizeBytes = 1024 * 1024) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        
        let quality = 0.9;
        const MAX_ITERATIONS = 10;
        
        // Calculate initial dimensions with max width/height constraints
        const MAX_WIDTH = 1920;
        const MAX_HEIGHT = 1080;
        let width = img.width;
        let height = img.height;
        
        // Scale down if image is too large
        if (width > MAX_WIDTH || height > MAX_HEIGHT) {
          if (width > height) {
            height = Math.round((height * MAX_WIDTH) / width);
            width = MAX_WIDTH;
          } else {
            width = Math.round((width * MAX_HEIGHT) / height);
            height = MAX_HEIGHT;
          }
        }

        const tryCompress = (iteration = 0) => {
          // Progressive dimension reduction
          let currentWidth = width;
          let currentHeight = height;
          
          if (iteration > 3) {
            const scaleFactor = Math.pow(0.8, iteration - 3);
            currentWidth = Math.floor(width * scaleFactor);
            currentHeight = Math.floor(height * scaleFactor);
          }
          
          canvas.width = currentWidth;
          canvas.height = currentHeight;

          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          const dataUrl = canvas.toDataURL("image/jpeg", quality);
          const base64 = dataUrl.split(",")[1];

          // More accurate byte size calculation
          const byteSize = Math.round((base64.length * 3) / 4);
          
          console.log(`Iteration ${iteration}: Quality=${quality}, Dimensions=${currentWidth}x${currentHeight}, Size=${byteSize} bytes`);

          if (byteSize <= maxSizeBytes || iteration >= MAX_ITERATIONS) {
            resolve({ 
              base64, 
              fileType: "image/jpeg", 
              mediaType: "image" 
            });
          } else {
            // Reduce quality first, then dimensions
            if (quality > 0.3) {
              quality = Math.max(0.3, quality - 0.15);
            }
            tryCompress(iteration + 1);
          }
        };

        tryCompress();
      };

      img.onerror = () => reject(new Error("Failed to load image"));
      img.src = reader.result;
    };

    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });
};

export default compressImage;